import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import security from '../app/roles/security';
import roles from '../app/roles/roles';
import appStore from '../app/mobx/appStore';
import { Button } from '@utahdts/dts-react-common';
import historyStore from '../app/mobx/historyStore';
import RateLimitBanner from '../misc/RateLimitBanner';
import ReactiveImage from '../misc/ReactiveImage';

const defaultMenu = {
  report: {
    text: 'Report',
    roles: [roles.admin, roles.dev],
    onClick: () => historyStore.forward('/report'),
  },
  listings: {
    text: 'Drug Listings',
    roles: [roles.admin, roles.dev, roles.orgAdmin],
    onClick: () => historyStore.forward('/listings'),
  },
  wacs: {
    text: 'WAC History',
    roles: [roles.admin, roles.dev, roles.orgAdmin],
    onClick: () => historyStore.forward('/wacs'),
  },
  approvals: {
    text: 'Approval History',
    roles: [roles.admin, roles.dev, roles.orgAdmin],
    onClick: () => historyStore.forward('/approvals'),
  },
  patents: {
    text: 'Patent History',
    roles: [roles.admin, roles.dev, roles.orgAdmin],
    onClick: () => historyStore.forward('/patents'),
  },
  users: {
    text: 'Users',
    roles: [roles.admin, roles.dev, roles.orgAdmin],
    onClick: () => historyStore.forward('/users'),
  },
  companies: {
    text: 'Companies',
    roles: [roles.admin, roles.dev],
    onClick: () => historyStore.forward('/companies'),
  },
  company: {
    text: 'Company',
    roles: [roles.orgAdmin],
    onClick: () => historyStore.forward('/company'),
  },
};

const Home = () => {
  const [menu, setMenu] = useState([]);
  const [currentImage] = useState('homePageGraphic1.png');

  const setButtons = () => {
    let buttons = Object.keys(defaultMenu)
      .filter((menuKey) => {
        let allow = true;

        if (defaultMenu[menuKey].roles) {
          allow = security.hasAnyRole(defaultMenu[menuKey].roles);
        }

        if (menuKey === 'switch') {
          allow =
            !security.hasAnyRole([roles.dev, roles.admin]) &&
            appStore.loggedInUser?.roles
              ? [
                  ...new Set(
                    appStore.loggedInUser?.roles.map((role) => role.org),
                  ),
                ].length > 1
              : false;
        }

        return allow;
      })
      .map((menuKey) => defaultMenu[menuKey]);
    setMenu(buttons);
  };

  const wakeReportUp = () => {
    const otherParams = {
      method: 'GET',
    };
    security.hasAnyRole([roles.dev, roles.admin]) &&
      fetch('/gen-report-ws', otherParams).then((response) =>
        console.log(response),
      );
  };

  useEffect(() => {
    setButtons();
  }, [appStore.currentOrg]);

  useEffect(() => {
    setButtons();
    wakeReportUp();
  }, []);

  return (
    <div key="home" className="home-wrapper">
      {/* --- TOP SECTION (Full Width) --- */}
      <h2>Welcome, {appStore.loggedInUser?.name || 'user'}</h2>
      
      {appStore.loggedInUser?.orgAdminOrgIds && appStore.loggedInUser.orgAdminOrgIds.length > 0 && (
        <p className="small-text" data-testid="home-org-admin-list">
          Your Organizations: {appStore.loggedInUser.orgAdminOrgIds.join(', ')}
        </p>
      )}
      
      <RateLimitBanner />

      {/* --- BOTTOM SECTION (Split Layout) --- */}
      {/* Add a new wrapper div just for the side-by-side panes */}
      <div style={{ display: 'flex', width: '100%' }}> 
        
        <div className="home__left-pane" style={styles.leftPane}>
            {menu.map((i) => (
              <div key={i.text}>
                <Button label={i.text} onClick={i.onClick} />
              </div>
            ))}
        </div>

        <div style={styles.rightPane}>
          <ReactiveImage fileName={currentImage} altText="UID Pharma Home Page Cartoon" />
        </div>

      </div>
    </div>
  );
};

// Inline styles for easy copying, but you can move these to a .css file!
const styles = {
  container: {
    display: 'flex',          // This creates the side-by-side layout
    minHeight: '100vh',       // Makes the layout span the full height of the screen
    fontFamily: 'sans-serif',
    color: '#333'
  },
  leftPane: {
    flex: '0 0 250px',        // Fixed width of 250px. It will not grow or shrink.
    backgroundColor: '#f8f9fa',
    padding: '20px',
    borderRight: '1px solid #ddd',
    display: 'flex',
    flexDirection: 'column',  // Stacks the buttons vertically
    gap: '12px',              // Adds space between the buttons
  },
  rightPane: {
    flex: 1,                  // Takes up all the remaining space
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',     // Centers the image horizontally
    justifyContent: 'center', // Centers the image vertically
    backgroundColor: '#ffffff'
  }
};

export default observer(Home);
